export default "__VITE_ASSET__Bd77fg19__"